/**
 * @generated SignedSource<<67438166c1ea80979332370dcd121ccd>>
 * @relayHash 6fb550e4917f3d83053710ef8061a8d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9c9c6383770c3a29ea72db2a6e03f9418b0a424999bd5a3b88f28941cf53dadf

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraFieldSetsMutationInput = {
  replaceFieldSetsInput?: JiraReplaceIssueSearchViewFieldSetsInput | null | undefined;
  resetToDefaultFieldSets?: boolean | null | undefined;
  scopedResetToDefaultFieldSets?: JiraScopedResetFieldsetsInput | null | undefined;
};
export type JiraReplaceIssueSearchViewFieldSetsInput = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  inclusive?: boolean | null | undefined;
  nodes: ReadonlyArray<string>;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraScopedResetFieldsetsInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  doReset?: boolean | null | undefined;
};
export type useColumnResetMutation$variables = {
  fieldSetsInput?: JiraFieldSetsMutationInput | null | undefined;
  id: string;
};
export type useColumnResetMutation$data = {
  readonly jira: {
    readonly updateFieldSetsView: {
      readonly success: boolean;
      readonly view: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useColumnResetMutation$rawResponse = {
  readonly jira: {
    readonly updateFieldSetsView: {
      readonly success: boolean;
      readonly view: {
        readonly __typename: string;
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useColumnResetMutation = {
  rawResponse: useColumnResetMutation$rawResponse;
  response: useColumnResetMutation$data;
  variables: useColumnResetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useColumnResetMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraFieldSetsViewPayload",
            "kind": "LinkedField",
            "name": "updateFieldSetsView",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "view",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useColumnResetMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraFieldSetsViewPayload",
            "kind": "LinkedField",
            "name": "updateFieldSetsView",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "view",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9c9c6383770c3a29ea72db2a6e03f9418b0a424999bd5a3b88f28941cf53dadf",
    "metadata": {},
    "name": "useColumnResetMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "827cdf8b9668f442c7bcb19508ad0e31";

export default node;
